import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateGroupMutationVariables = Types.Exact<{
  data: Types.CreateGroupInput;
}>;


export type CreateGroupMutation = { createGroup: { __typename: 'ContentCollectionGroupType', id: string, name: string } | { __typename: 'UserCollectionGroupType' } };


export const CreateGroupDocument = /*#__PURE__*/ gql`
    mutation createGroup($data: CreateGroupInput!) {
  createGroup(data: $data) {
    __typename
    ... on ContentCollectionGroupType {
      id
      name
    }
  }
}
    `;

export function useCreateGroupMutation() {
  return Urql.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument);
};